/* eslint-disable max-lines */
import { templateDownloadApi } from '@mdm/api/customer/customerPersonResponsibleImport';
import { importKpiReportList } from '@mdm/api/targetModdeules/kpiReport.js';

export const config = {
    name: 'kpiReport',
    searchFields: [
        // {
        //     name: '标题',
        //     value: 'title',
        //     type: 'input',
        //     isFixed: true,
        //     span: 5
        // },
        {
            name: '目标类型',
            value: 'goalTypeName',
            type: 'advance',
            advanceConfig: [
                { 'prop': 'goalTypeName', 'value': '类型名称' },
                { 'prop': 'goalTypeCode', 'value': '类型编码' }
            ],
            tableConfig: [
                { 'prop': 'goalTypeCode', 'value': '类型编码' },
                { 'prop': 'goalTypeName', 'value': '类型名称' }
            ],
            method: 'post',
            prefix: '/api-lcrm',
            advanceUrl: '/goal/manage/goalType/page',
            cbParams: ['goalTypeCode#goalTypeCode', 'goalTypeName#goalTypeName'],
            isFixed: true,
            span: 5
        },
        {
            name: '状态',
            value: 'kpiStatus',
            type: 'select',
            optionNum: 'GOAL_MANAGE_KPI_STATUS',
            isFixed: true,
            span: 5
        },
        {
            name: '目标大类',
            value: 'goalCategory',
            type: 'input',
            isFixed: true,
            span: 5
        },
        {
            name: '目标小类',
            value: 'kpiName',
            type: 'input',
            isFixed: false,
            span: 5
        }
    ],
    selection: true,
    index: false,
    columns: [
        // {
        //     label: '标题',
        //     prop: 'title',
        //     minWidth: 100
        // },
        {
            label: '指标编码',
            prop: 'kpiCode',
            minWidth: 160
        },
        {
            label: '关联目标类型',
            prop: 'goalTypeName',
            minWidth: 100
        },
        {
            label: '目标大类',
            prop: 'goalCategory',
            minWidth: 100
        },
        {
            label: '目标小类',
            prop: 'kpiName',
            minWidth: 100
        },
        {
            label: '指标单位',
            prop: 'kpiUnit'
        },
        {
            label: '指标定义',
            prop: 'kpiDefinition'
        },
        {
            label: '计算规则',
            prop: 'calculationRule'
        },
        {
            label: '状态',
            prop: 'kpiStatus',
            type: 'select',
            optionsKey: 'GOAL_MANAGE_KPI_STATUS'
        },
        {
            label: '汇总',
            prop: 'kpiSumLogic',
            type: 'select',
            optionsKey: 'GOAL_KPI_SUM_LOGIC'
        },
        {
            label: '创建人',
            prop: 'createUserName'
        },
        {
            label: '创建时间',
            prop: 'createTime',
            minWidth: 150
        },
        {
            label: '修改人',
            prop: 'updateUserName'
        },
        {
            label: '修改时间',
            prop: 'updateTime',
            minWidth: 150
        }
    ],
    importConfig: {
        downBtn: true,
        downParams: {
            fileName: '目标管理指标导入模板.xlsx',
            fileId: 'goalManageKpiAddImport.xlsx'
        },
        accept: '.xlsx,.xls',
        limtSizeKey: 'goalKpiImport',
        fileType: '只能上传Excel文件',
        downloadApi: templateDownloadApi,
        importApi: importKpiReportList
    }
};
